module.exports = __webpack_public_path__ + "r-v3/img/control_camera_inactive.fdd93109.svg";